import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {ErrorHandler, NgModule, Injector} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import 'rxjs/add/observable/throw';
import '../utils/date/date-prototype.utils';
import '../utils/number/number-prototype.utils';
import '../utils/string/string-prototype.utils.ts';
import '../utils/window/window-prototype.utils';
import {setAppInjector} from './app-injector.helper';
import {MyApp} from './app.component';
import {ApplyToAllModalModule} from './content/shared/components/apply-to-all-modal/apply-to-all-modal.module';
import {EditImageModalModule} from './content/shared/components/edit-image-modal/edit-image-modal.module';
import {BodyInputModalModule} from './content/shared/components/inputs/body/body-input-modal/body-input-modal.component.module';
import {CaptionInputModalModule} from './content/shared/components/inputs/caption/caption-input-modal/caption-input-modal.component.module';
import {PreviewModalModule} from './content/shared/components/preview-modal/preview-modal.module';
import {ScheduleModalModule} from './content/shared/components/schedule-modal/schedule-modal.module';
import {TemplateModalModule} from './content/shared/components/template-modal/template-modal.module';
import {TemplateListService} from './content/shared/services/index';
import {EnvironmentsModule} from './environment-variables/environment-variables.module';
import {ImageListingModalModule} from './shared/components/image-listing-modal/image-listing-modal.module';
import {SliderModule} from './shared/components/image/slider';
import {PrimaryTopicModalModule} from './shared/components/metadata-menu/topic/primary-topic-modal/primary-topic-modal.component.module';
import {SecondaryTopicModalModule} from './shared/components/metadata-menu/topic/secondary-topic-modal/secondary-topic-modal.component.module';
import {AdvTechMobileService} from './shared/services/advtech/mobile/mobile.service';
import {FirebaseStorageService} from './shared/services/firebase/firebase-storage.service';
import {WindowService} from './shared/services/window/window.service';
import {LoginFormComponent} from './user/login/components/form/login/login-form.component';
import {UserLoginModule} from './user/login/login.module';
import {UserAuthenticationService} from './user/login/services/user-authentication.service';

/**
 * Bootstraps and inits the app
 */
@NgModule({
  bootstrap: [IonicApp],
  declarations: [
    MyApp,
  ],
  entryComponents: [
    MyApp,
    LoginFormComponent,
  ],
  imports: [
    IonicModule.forRoot(MyApp),
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,
    EnvironmentsModule,
    TemplateModalModule,
    ScheduleModalModule,
    PreviewModalModule,
    ApplyToAllModalModule,
    ImageListingModalModule,
    EditImageModalModule,
    PrimaryTopicModalModule,
    SecondaryTopicModalModule,
    EditImageModalModule,
    UserLoginModule,
    SliderModule,
    BodyInputModalModule,
    CaptionInputModalModule,
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    WindowService,
    FirebaseStorageService,
    AdvTechMobileService,
    TemplateListService,
    UserAuthenticationService,
  ],
})
export class AppModule {
  constructor(injector: Injector) {
    setAppInjector(injector);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts